<template>
  <main>
    <b-row align-v="center" class="m-3">
      <b-col class="mt-2 text-center" cols="12">
        <!-- To manage Application Access for users not listed below
        <a href="/custom-application-access">Click here</a> -->
        If you do not see a member of your site staff listed below and need to request application
        access, please review the Application Access Manager section on the Support Page
      </b-col>
    </b-row>

    <hr class="solid mx-3" />

    <b-form @submit.prevent="onSubmit">
      <b-row class="m-3">
        <b-col cols="12" lg="6" md="6" sm="6" xl="2">
          <b-form-input
            id="filterStudy"
            v-model="filters.study"
            class="filterInput mt-2"
            placeholder="Study ID"
            type="search"
          ></b-form-input>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="6" xl="2">
          <b-form-input
            id="filterUser"
            v-model="filters.site"
            class="filterInput mt-2"
            placeholder="Site ID"
            type="search"
          ></b-form-input>
        </b-col>
        <b-col cols="12" lg="12" md="12" sm="12" xl="4">
          <b-form-input
            id="filterStudy"
            v-model="filters.name"
            class="filterInput mt-2"
            placeholder="Filter by First Name, Last Name"
            type="search"
          ></b-form-input>
        </b-col>
        <b-col class="text-right pl-0" cols="12" lg="12" md="12" sm="12" xl="2">
          <b-button class="buttonStyle pr-4 pl-4 mt-2" pill type="submit" variant="primary"
            >Filter
          </b-button>
          <b-button class="buttonStyle mt-2" pill variant="danger" @click="clear()">Clear</b-button>
        </b-col>
      </b-row>
    </b-form>
  </main>
</template>
<script>
  export default {
    name: 'manage-access-filters',
    props: {
      userFilter: String,
    },
    data() {
      return {
        filters: {
          study: null,
          site: null,
          name: null,
        },
      };
    },
    methods: {
      onInput(event) {
        this.$emit('update:userFilter', event);
      },
      onSubmit() {
        this.$emit('filter', this.filters);
      },
      clear() {
        this.filters = {
          study: null,
          site: null,
        };
        this.$emit('update:userFilter', null);
        this.$emit('filter', this.filters);
      },
    },
  };
</script>
<style scoped>
  .buttonStyle {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #ffffff;
  }
</style>
